import _ from 'lodash'
import client, { fetch } from '@/base-http'
import { Country, AdminDivision, PostalCode } from '@/modules/geo/types'
import {Post} from '@/modules/blog/types';

/**
 * Obtiene la lista de países del servidor
 *
 * @param locale
 */
export const getCountries = async (locale = '') => {
    const params = new URLSearchParams()
    if (locale) {
        params.append('locale', locale)
    }

    const response = await client.get('/geo/countries', { params })
    const data: object[] = response.data
    if (!Array.isArray(data)) {
        throw new Error('La lista de países obtenida del servidor no es un array de objetos')
    }

    return data.map(country => Country.convert(country))
}

/**
 * Obtiene una lista de divisiones administrativas de un estado
 *
 * @param country País a filtrar
 * @param level Nivel de división a filtrar
 */
export const getAdminDivisions = async (country: Country, level: 0 | 1 | 2 | 3) => {
    const params = new URLSearchParams()
    params.append('country', country.code)
    if (level) {
        params.append('level', level.toString())
    }

    const response = await client.get('geo/admin-divisions', { params })
    const data: object[] = response.data

    if (!Array.isArray(data)) {
        throw new Error(`La lista de divisiones administrativas debe ser un array pero se obtuvo ${typeof(data)}`)
    }

    return data.map(division => AdminDivision.convert(division))
}


/**
 * Busca un códigos postales por código
 * @param postalCode { string }
 */
export async function findPostalCodes (code: string) {
    const data = await fetch('/geo/postal-codes', {
        params: { code },
    })

    if (!Array.isArray(data)) {
        throw new Error('Se esperaba una lista con los códigos postales')
    }

    return data.map(pc => PostalCode.deserialize(pc))
}

/**
 * Obtener un código postal por identificador interno.
 *
 * @param id Identificador del código postal
 * @return PostalCode | null El código postal o nulo si este no existe
 */
export async function getPostalCode (id: number): Promise<PostalCode | null> {
    try {
        const data = await fetch(`/geo/postal-codes/${id}`)

        return PostalCode.deserialize(data)
    } catch (e) {
        // El servidor ha retornado una respuesta con código 404, se retorna nulo
        if (e.response && e.response.status === 404) {
            return null
        }

        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}
